import { act } from "react"


export const initialCart = [
    {name: "Hat",price: 4.99, image: "/images/hat.jpg", quantity: 0, inCart: false},
    {name: "Hoodie",price: 9.99, image: "/images/hoodie.webp", quantity: 0},
    {name: "Joggers",price: 9.99, image: "https://static-assets.codecademy.com/Courses/Learn-Redux/codecademy-store/sweatpants.jpg", quantity: 0},
    {name: "Bag", price: 14.99, image: "https://tailwindcss.com/plus-assets/img/ecommerce-images/product-page-03-product-01.jpg", quantity: 0}
]


export const addToCart = (name) => {
    return {
        type:"cart/addToCart",
        payload: name
    }
}

export const changeQuantity = (name, quantity) => {
    return {
        type: "cart/changeQuantity",
        payload: {name, quantity}
    }
}

export const cartReducer = (cart = initialCart, action) => {
    const name = action.payload
    switch (action.type){
        case ("cart/addToCart"): {
            let newItem
            let filteredy
            const checkExists = cart?.find(item => item.name === action.payload)
            if (checkExists.quantity === 0){
                
                newItem = {...checkExists, quantity: 1}
                const filtered = cart.filter(item => item.name != name)
              
                return [...filtered, newItem]

            }
            else if (checkExists.quantity > 0){
                newItem = {...checkExists, quantity: checkExists.quantity + 1}
                filteredy = cart.filter(item => item.name != name)

                const updatedCart = cart.map(item => item.name === checkExists.name ? {...item , quantity: item.quantity + 1} : item)
                return updatedCart
            }
           
           
        }
        case ("cart/changeQuantity"): {
            const {name, quantity} = action.payload
            console.log(name)
            const mapped = cart.map(item => item.name === name ? { ...item, quantity: item.quantity + quantity } : item);
              
            return mapped
        }
        default: {
            return cart
        }
    }
}